import {  MultiSelectTheme } from 'chakra-multiselect'

export const MultiSelect = {
  components: {
    MultiSelect: MultiSelectTheme,
  },
};
